// Points for the Organic vs AI Mismatch scatter, from the P16 snapshot's `value_breakdown`:
//
//   { query, organic_position, ai_answers, providers_answering, providers_mentioning,
//     ai_mention_pct, ai_mention_count, mismatch_score }
//
// `ai_mention_pct` is providers_mentioning ÷ providers_answering × 100, computed by the backend; it
// is null when no provider answered the query.

/**
 * Colour bucket for a query whose row carries no `mismatch_type`.
 *
 * @param {number} score the row's `mismatch_score`
 * @returns {'aligned_strong'|'moderate_or_weak'|'organic_strong_ai_weak'}
 */
export function bucketByMismatchScore(score) {
  if (score < 0.5) return 'aligned_strong';
  if (score < 2) return 'moderate_or_weak';
  return 'organic_strong_ai_weak';
}

/**
 * The scatter points for the P16 rows.
 *
 * A row is plotted only with both an organic rank and an `ai_mention_pct`: a query no provider
 * answered has no AI rate, and drawing it at 0 would read as "AI ignores you".
 *
 * @param {Array<object>} rows P16 `value_breakdown` rows
 * @returns {Array<{query: string, organic: number, ai: number, type: string}>}
 */
export function mismatchScatterPoints(rows) {
  return (Array.isArray(rows) ? rows : [])
    .map((r) => ({
      query: r.query || r.prompt_text,
      organic: r.organic_position != null ? Number(r.organic_position) : (r.organic_rank != null ? Number(r.organic_rank) : null),
      ai: r.ai_mention_pct != null ? Number(r.ai_mention_pct) : null,
      type: r.mismatch_type || bucketByMismatchScore(Number(r.mismatch_score ?? 0)),
    }))
    .filter((p) => p.organic != null && Number.isFinite(p.ai));
}
